module.exports = __webpack_public_path__ + "static/media/34DSS10.e83b9bdf.jpg";